import React, {useEffect, useState} from 'react';
import styles from './WorkersList.module.scss';
import {useNavigate} from 'react-router-dom';
import {TBody} from "../../../common/TActions/TBody";
import {TSort} from "../../../common/TSort/TSort";
import {PaginationBottom} from "../../../common/PaginationBottom/PaginationBottom";
import {commonServices} from "../../../../api/commonServices";
import {filterDate, searchOptions, tableTitle} from "./data";
import {DirectionService} from "../../../../api/directionService";

// Main component for displaying the list of workers
const ClinicList = () => {
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [workers, setWorkers] = useState([]); // State to hold workers data

    const [searchTerm, setSearchTerm] = useState(''); // State for the search term
    const [perPage, setPerPage] = useState(10); // State for items per page
    const [limit, setLimit] = useState(0); // Total number of items
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [action, setAction] = useState(0); // Delete

    // State for holding filters used in fetching data
    const [filters, setFilters] = useState({
        id: '',
        name: '',
        edrpou: '',
        medicalDirector: '',
        city: '',
        offset: 0,
        limit: 10,
        sortBy: 'id', // Default sorting by id
    });

    // Handle filter change and reset pagination
    const handleFilterChange = (e) => {
        const {name, value} = e.target;
        setFilters({
            ...filters,
            [name]: value,
            offset: 0, // Reset pagination when filter changes
        });
        setCurrentPage(1);
    };

    // Unified useEffect for filtering, sorting, and pagination
    useEffect(() => {
        // Filter out empty filters
        const nonEmptyFilters = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value !== '')
        );

        const queryParams = new URLSearchParams(nonEmptyFilters).toString(); // Prepare query params for URL
        const fields = ['id', 'name', 'edrpou', 'medicalDirector', 'city', 'isDeleted'];

        // Fetch workers based on filters
        DirectionService.getHospital(queryParams).then(res => {
            if (res?.data){
                setWorkers(res?.data?.rows.map(item => {
                    return fields.reduce((acc, field) => {
                        acc[field] = item[field];
                        return acc;
                    }, {});
                })); // Set workers data
                setLimit(res?.data?.count); // Set total count of results
                navigate(`?${queryParams}`); // Update URL with filter parameters
            }
        });
    }, [filters, navigate, action]);

    // Handle change in the number of items per page
    const handleLimitChange = (e) => {
        const newPerPage = e.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            limit: newPerPage, // Update limit in filters
            offset: 0, // Reset pagination on limit change
        }));
        setPerPage(newPerPage);
        setCurrentPage(1); // Reset to first page
    };

    // Sort workers based on the selected field
    const sortByFilter = (sortField) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            sortBy: sortField, // Update sort field
            offset: 0, // Reset pagination on sorting
        }));

        setCurrentPage(1); // Reset to first page
    };

    // Handle page change for pagination
    const handlePaginationChange = (pageNum) => {
        const offset = pageNum * perPage; // Calculate offset based on page number
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: offset, // Update offset in filters
        }));
        setCurrentPage(pageNum + 1); // Update current page
    };

    useEffect(() => {
        setWorkers((prevUsers) => prevUsers.filter(user => user.id !== action));
    }, [action])

    return (
        <div className={styles['workers-page']}>
            <h1>Список клінік</h1>
            {/* Sorting and limit change component */}
            <TSort
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setSortField={sortByFilter}
                perPage={perPage}
                handleLimitChange={handleLimitChange}
                title={'Створити клініку'}
                navigateUrl={'/CreateClinic'}
                searchOptions={searchOptions}
            />
            <div className={styles['table-wrapper']}>
                <table className={styles['workers-table']}>
                    <thead>
                    <tr>{tableTitle.map((header, index) => <th
                        key={index}>{header}</th>)}</tr>
                    <tr>
                        {filterDate.map(({name, placeholder, type = 'text', options}, index) => (
                            <th key={index}>
                                {type == 'select' ? (
                                    <select name={name} value={filters[name]} onChange={handleFilterChange}>
                                        {options.map((option, optIndex) => (
                                            <option key={optIndex}
                                                    value={option?.value}>{option?.name}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={type}
                                        name={name}
                                        value={filters[name]}
                                        onChange={handleFilterChange}
                                        placeholder={placeholder}
                                    />
                                )}
                            </th>
                        ))}
                        <th></th>
                    </tr>
                    </thead>
                    {/* Table body to display filtered workers data */}
                    <TBody paginatedInfo={workers} activeArchive={true} setAction={setAction} deleteUrl={'direction/hospital'} handleUrl={'EditClinic'}
                           activeRead={false} activeDelete={false} deleteTitle={"Клініку успішно архівовано"}/>
                </table>
            </div>

            {/* Pagination component */}
            <PaginationBottom limit={limit} perPage={perPage} currentPage={currentPage} setCurrentPage={handlePaginationChange}/>
        </div>
    );
};

export default ClinicList;
